import { KeyValueObject } from '@questwork/q-utilities'
import { Delegate } from '../delegate'
import { PopulateTopic } from '../populateTopic'
import { Topic } from '../topic'

class Session {
  constructor(options = {}) {
    options = options || {}
    this.id = options.id
    this.abstractGroup = options.abstractGroup || ''
    this.category = options.category
    this.chairmans = Delegate.initOnlyValidFromArray(options.chairmans)
    this.code = options.code
    this.date = options.date
    this.endTime = options.endTime
    this.endDateTimeUTC = options.endDateTimeUTC
    this.eventShortCode = options.eventShortCode
    this.panelists = Delegate.initOnlyValidFromArray(options.panelists)
    this.populateTopics = PopulateTopic.initOnlyValidFromArray(options.populateTopics)
    this.promotionUrl = options.promotionUrl
    this.remarks = KeyValueObject.initOnlyValidFromArray(options.remarks)
    this.startTime = options.startTime
    this.startDateTimeUTC = options.startDateTimeUTC
    this.subspecialty = options.subspecialty
    this.synopsis = options.synopsis
    this.theme = options.theme
    this.topics = Topic.initOnlyValidFromArray(options.topics)
    this.type = options.type
    this.url = options.url
    this.venue = options.venue
  }

  // Class methods
  static init(options) {
    if (options instanceof Session) {
      return options
    }
    const instance = new Session(options)
    return instance.isValid ? instance : null
  }
  static initFromArray(arr) {
    if (Array.isArray(arr)) {
      return arr.map(this.init)
    }
    return []
  }
  static initOnlyValidFromArray(arr = []) {
    return this.initFromArray(arr).filter((i) => i)
  }

  // getters
  get isValid() {
    return !!this.theme && !!this.date && !!this.startTime && !!this.endTime
  }

  get $date() {
    const date = (this.date || '').replace(/-/g, '/')
    return new Date(date)
  }

  get displayDateTime() {
    const date = new Date(this.date)
    const monStr = date.toLocaleString('en', { month: 'long' })
    const dateStr = date.getUTCDate()
    return `${monStr} ${dateStr} ${this.startTime} - ${this.endTime}`
  }
  get displayTime() {
    const arr = []
    if (this.startTime) {
      arr.push(this.startTime)
    }
    if (this.endTime) {
      arr.push(this.endTime)
    }
    return arr.join(' - ')
  }
  get isAfterEnd() {
    return new Date().getTime() > new Date(this.endDateTimeUTC).getTime()
  }
  get isLivestream() {
    return KeyValueObject.getValuesByKey(this.remarks, 'zoomWebinarId').length > 0
  }

  get sessionBegin() {
    return `${this.date} ${this.startTime}`
  }

  get sessionEnd() {
    return `${this.date} ${this.endTime}`
  }

  get speakers() {
    return this.topics.reduce((acc, t) => {
      if (t.hasSpeaker) {
        return acc.concat(t.speaker)
      }
      return acc
    }, [])
  }
}

export default {
  Session
}
export {
  Session
}
